<template>
  <div v-if="tableName" class="datatable-container">
    <!-- Row 1: Table Name -->
    <div class="datatable-header">{{ tableName }}</div>

    <!-- Row 2: CRUD Toolbar -->
    <Toolbar>
      <div class="p-toolbar-group-left">
        sdfsdf
        <Button label="Select All" icon="pi pi-check-square"/>
        <Button label="Add" icon="pi pi-plus"/>
        <Button label="Edit" icon="pi pi-pencil"/>
        <Button label="Delete" icon="pi pi-trash"/>
<!--        <Dropdown :options="crudOptions" placeholder="More">-->
<!--          <template v-slot:option="option">-->
<!--            <i :class="'pi pi-' + option.value.icon"></i>-->
<!--            <span>{{ option.value.label }}</span>-->
<!--          </template>-->
<!--        </Dropdown>-->
      </div>

    </Toolbar>

    <!-- Row 3: Search bar with count of results per page -->
    <div class="p-toolbar datatable-subheader">
      <div class="p-inputgroup px-2 w-30rem">
        <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
        <InputText placeholder="Search" v-model="globalFilter"/>
      </div>

      <div class="p-inputgroup px-2 w-25rem">
        <span class="p-inputgroup-addon">Results per page:</span>
        <Dropdown :options="perPageOptions" :value="perPage" @change="changePerPage"/>
      </div>
    </div>

    <!-- Row 4: DataTable -->
    <DataTable :value="tableData" :paginator="true" :rows="perPage" :globalFilterFields="globalFilterFields"
               :selectionMode="selectionMode"
               :selection="selectedRows" @selectionChange="onSelectionChange" :rowHover="true">
      <Column field="id" header="ID" sortable/>
      <Column field="name" header="Name" sortable/>
      <Column field="email" header="Email" sortable/>
      <Column field="status" header="Status" :body="statusBodyTemplate"/>
    </DataTable>

    <!-- Row 5: Paginator -->
    <Paginator :totalRecords="tableData.length" :rows="perPage" @pageChange="onPageChange"/>
  </div>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    tableName: {
      type: String,
      required: true,
    },
    tableData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      globalFilter: '',
      perPage: 10,
      perPageOptions: [10, 25, 50],
      crudOptions: [
        {label: 'Import', icon: 'upload'},
        {label: 'Export', icon: 'download'},
        {label: 'Print', icon: 'print'},
        {label: 'Filter', icon: 'pi pi-filter'},
        {label: 'Update', icon: 'pi pi-refresh'},
        {label: 'Three dots', icon: 'pi pi-ellipsis-h'},
      ],
      selectedRows: [],
      selectionMode: 'multiple',
      globalFilterFields: ['name', 'email'],
    };
  },
  methods: {
    onPageChange(event) {
      this.perPage = event.rows;
    },
    changePerPage(event) {
      this.perPage = event.value;
    },
    onSelectionChange(event) {
      this.selectedRows = event.value;
    },
    statusBodyTemplate(rowData) {
      const status = rowData.status.toLowerCase();
      return (
        <span class={`status-badge ${status}`}>
          <i class={`pi pi-${status === 'active' ? 'check' : 'times'}`}></i>
          {rowData.status}
        </span>
      );
    },
  },
};
</script>

<style scoped>
.datatable-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.datatable-header {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0.5rem 0;
}

.datatable-subheader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  font-weight: bold;
  border-radius: 0.25rem;
  text-transform: capitalize;

  &.active {
    background-color: #c8e6c9;
    color: #43a047;
  }

  &.inactive {
    background-color: #ffcdd2;
    color: #e53935;
  }
}

.p-dropdown {
  width: 150px;
}
</style>
